export default function Hero() {
  return (
    <section className="relative mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between px-6 py-10 lg:flex-row lg:px-10 lg:py-16">
      {/* Left Content */}
      <div className="mb-8 flex w-full flex-col items-start justify-start lg:mb-0 lg:w-1/2">
        <div className="mb-6 text-4xl font-bold leading-tight lg:text-5xl">
          <span className="font-['Poppins'] text-[#475467]">
            Empowering Tech Workers
          </span>
          <br />
          <span className="font-['Poppins'] text-[#d91f2e]">
            To Work and Thrive in Japan
          </span>
        </div>
      </div>

      {/* Right Content - Image */}
      <div className="flex w-full justify-center lg:w-1/2 lg:justify-end">
        <img
          src="/img/about-us/DSC05371-1.png"
          alt="Team working together"
          className="h-auto w-full max-w-[560px] rounded-lg object-cover"
          sizes="(max-width: 767px) 100vw, 560px"
        />
      </div>
    </section>
  )
}
